/**
 * Keeps an old submission identity from restoring the selected conversation
 * after the user has explicitly started a fresh chat.
 */
export function createFreshChatConversationGuard() {
  const blockedConversationIds = new Set<string>();
  let freshChatPending = false;
  let freshSendStarted = false;

  return {
    beginNewChat(conversationId: string | number | null): void {
      if (conversationId !== null) {
        blockedConversationIds.add(String(conversationId));
      }
      freshChatPending = true;
      freshSendStarted = false;
    },

    prepareSend(
      conversationId: string | number | null,
      clearConversationId: () => void,
    ): void {
      if (!freshChatPending) return;
      freshSendStarted = true;
      if (conversationId !== null) clearConversationId();
    },

    acceptResponseIdentity(conversationId: string | number): boolean {
      const candidate = String(conversationId);
      if (blockedConversationIds.has(candidate)) return false;
      if (freshChatPending) {
        if (!freshSendStarted) return false;
        freshChatPending = false;
        freshSendStarted = false;
      }
      return true;
    },

    clearForConversationSelection(conversationId: string | number): void {
      // Explicitly selecting a conversation permits that id again, but IDs
      // blocked by an earlier New Chat stay blocked against late stream frames.
      blockedConversationIds.delete(String(conversationId));
      freshChatPending = false;
      freshSendStarted = false;
    },

    isFreshChatPending(): boolean {
      return freshChatPending;
    },
  };
}
